// src/Components/Modals/IdleTimeoutModal.js
import React from 'react';
import { useAuth } from '../Context/AuthContext';
import ConfirmModal from './ConfirmModal';

const IdleTimeoutModal = () => {
  const { 
    showTimeoutModal, 
    countdown, 
    stayLoggedIn,
    handleLogoutFromModal
  } = useAuth();

  if (!showTimeoutModal) return null;

  return (
    <ConfirmModal
      show={showTimeoutModal}
      onClose={handleLogoutFromModal}
      onConfirm={stayLoggedIn}
      title="Session Expiring"
      message={`You have been inactive. Auto logout in ${countdown} seconds.`}
      confirmLabel="Stay Logged In"
      cancelLabel="Logout"
      variant="warning"
    />
  );
};

export default IdleTimeoutModal;